<main class="main-dashboard">
    <article class="main-canvas">
        <section class="canvas-container">
            <section class="dashboard-items">
                <div class="canvas-item">
                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-6">
                            <div class="d-flex align-items-center">
                                <div class="edit">
                                    <button (click)="backToOnboarding()">
                                        <span><i class="ri-arrow-left-line"></i></span>
                                    </button>
                                </div>
                                <h3 class="px-3">Onboarding User</h3>
                            </div>
                        </div>
                    </div>
                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-6 d-flex">
                            <h3><a (click)="openHrmonboarding()" class="active cursor-pointer">HR</a></h3>
                            <h3><a (click)="openndaonboarding()" class="cursor-pointer">NDA</a></h3>
                            <h3><a (click)="openItonboarding()" class="cursor-pointer">IT</a></h3>
                        </div>
                    </div>
                    <div class="canvas-data">
                        <form [formGroup]="usersForm">
                            <div class="row">
                                <div class="col-sm-12">
                                    <h5>Personal Information</h5>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="firstName" required />
                                            <label class="floating-label-special">Employee First Name*</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                        <mat-error *ngIf="f.firstName.touched && f.firstName.invalid"
                                            class="alert alert-danger">
                                            <mat-error *ngIf="f.firstName.errors.required">First Name is
                                                required</mat-error>
                                        </mat-error>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="middleName" required />
                                            <label class="floating-label-special">Employee Middle Name*</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                        <mat-error *ngIf="f.middleName.touched && f.middleName.invalid"
                                            class="alert alert-danger">
                                            <mat-error *ngIf="f.middleName.errors.required">Middle Name is
                                                required</mat-error>
                                        </mat-error>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="lastName" required />
                                            <label class="floating-label-special">Employee Last Name*</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                        <mat-error *ngIf="f.lastName.touched && f.lastName.invalid"
                                            class="alert alert-danger">
                                            <mat-error *ngIf="f.lastName.errors.required">Last Name is
                                                required</mat-error>
                                        </mat-error>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="displayName" required />
                                            <label class="floating-label-special" for="displayName">Display
                                                Name*</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                        <mat-error *ngIf="f.displayName.touched && f.displayName.invalid"
                                            class="alert alert-danger">
                                            <mat-error *ngIf="f.displayName.errors.required">Display Name is
                                                required</mat-error>
                                        </mat-error>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="alternateEmailId" required />
                                            <label class="floating-label-special">Personal Email*</label>
                                            <i class="ri-mail-line"></i>
                                        </div>
                                        <mat-error *ngIf="f.alternateEmailId.touched && f.alternateEmailId.invalid"
                                            class="alert alert-danger">
                                            <mat-error *ngIf="f.alternateEmailId.errors.required">Email is
                                                required</mat-error>
                                        </mat-error>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="phoneNo" required />
                                            <label class="floating-label-special">Contact Number*</label>
                                            <i class="ri-smartphone-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <input formControlName="birthDate" type="date" />
                                            <label for="birthDate" class="floating-label-special">Birth Date</label>
                                            <i class="ri-file-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <h5>Company Information</h5>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="localId" required />
                                            <label class="floating-label-special">Employee Id*</label>
                                            <i class="ri-code-box-line"></i>
                                        </div>
                                        <mat-error *ngIf="f.localId.touched && f.localId.invalid"
                                            class="alert alert-danger">
                                            <mat-error *ngIf="f.localId.errors.required">Employee Id is
                                                required</mat-error>
                                            <mat-error *ngIf="f.localId.errors.pattern">Employee Id starts with # and
                                                followed by numbers only</mat-error>
                                        </mat-error>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="userId" required />
                                            <label class="floating-label-special">User Id*</label>
                                            <i class="ri-code-box-line"></i>
                                        </div>
                                        <mat-error *ngIf="f.userId.touched && f.userId.invalid"
                                            class="alert alert-danger">
                                            <mat-error *ngIf="f.userId.errors.required">User Id is required</mat-error>
                                        </mat-error>
                                    </div>
                                </div>
                                <div class="col-sm-4" *ngIf="!this.userCreationId">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="password" required />
                                            <label class="floating-label-special">Pragamana Password</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                        <mat-error *ngIf="f.password.touched && f.password.invalid"
                                            class="alert alert-danger">
                                            <mat-error *ngIf="f.password.errors.pattern"> Password must have at least 8
                                                chracters which contain at least one lowercase character,
                                                at least one uppercase character, at least one number and special
                                                character</mat-error>
                                        </mat-error>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <select formControlName="currentDesignation">
                                                <option *ngFor="let designation of designationArray"
                                                    [value]="designation">{{ designation }}</option>
                                            </select>
                                            <label class="floating-label-special">Current Designation*</label>
                                            <i class="ri-map-pin-user-line"></i>
                                        </div>
                                        <mat-error *ngIf="f.currentDesignation.touched && f.currentDesignation.invalid"
                                            class="alert alert-danger">
                                            <mat-error *ngIf="f.currentDesignation.errors.required">Designation is
                                                required</mat-error>
                                        </mat-error>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <select formControlName="department">
                                                <option *ngFor="let dept of departmentArray" [value]="dept">{{ dept }}
                                                </option>
                                            </select>
                                            <label class="floating-label-special">Department*</label>
                                            <i class="ri-building-line"></i>
                                        </div>
                                        <mat-error *ngIf="f.department.touched && f.department.invalid"
                                            class="alert alert-danger">
                                            <mat-error *ngIf="f.department.errors.required">Department is
                                                required</mat-error>
                                        </mat-error>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="date" formControlName="joinDate" required />
                                            <label class="floating-label floating-label-special">Joining Date*</label>
                                            <i class="ri-calendar-2-line"></i>
                                        </div>
                                        <mat-error *ngIf="f.localId.touched && f.localId.invalid"
                                            class="alert alert-danger">
                                            <mat-error *ngIf="f.localId.errors.required">Joining Date is
                                                required</mat-error>
                                        </mat-error>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <h5>Other Information</h5>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4" *ngIf="this.userCreationId">
                                    <div class="input">
                                        <div class="input-item">
                                            <select formControlName="status">
                                                <option value="" disabled selected>Select Status</option>
                                                <option value="withHrTeam">With Hr Team</option>
                                                <option value="withNDATeam">With NDA Team</option>
                                                <option value="withItTeam">With IT Team</option>
                                                <option value="waitingForApproval">Waiting For Approval</option>
                                                <option value="approved">Approved</option>
                                            </select>
                                            <label class="floating-label-special">Status</label>
                                            <i class="ri-file-list-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4" *ngIf="!this.userCreationId">
                                    <div class="input">
                                        <div class="input-item">
                                            <select formControlName="status" disabled>
                                                <option value="" disabled selected>Select Status</option>
                                                <option value="withHrTeam">With Hr Team</option>
                                                <option value="withNDATeam">With NDA Team</option>
                                                <option value="withItTeam">With IT Team</option>
                                                <option value="waitingForApproval">Waiting For Approval</option>
                                                <option value="approved">Approved</option>
                                            </select>
                                            <label class="floating-label-special">Status</label>
                                            <i class="ri-file-list-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <select formControlName="location" placeholder="location">
                                                <option value="" disabled selected>Select location</option>
                                                <option value="pune">Pune</option>
                                            </select>
                                            <label class="floating-label-special">Location*</label>
                                            <i class="ri-map-pin-line"></i>
                                        </div>
                                        <mat-error *ngIf="f.location.touched && f.location.invalid"
                                            class="alert alert-danger">
                                            <mat-error *ngIf="f.location.errors.required">Location is
                                                required</mat-error>
                                        </mat-error>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <input list="taskOwnerDatalist" formControlName="supervisonName" required />
                                            <datalist id="taskOwnerDatalist">
                                                <option [value]="item" *ngFor="let item of userDropdownList"></option>
                                            </datalist>
                                            <label class="floating-label floating-label-special">Supervisor*</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                        <mat-error *ngIf="f.supervisonName.touched && f.supervisonName.invalid"
                                            class="alert alert-danger">
                                            <mat-error *ngIf="f.supervisonName.errors.required">Manager is
                                                required</mat-error>
                                        </mat-error>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <input list="taskOwnerDatalist" formControlName="managerName" required />
                                            <datalist id="taskOwnerDatalist">
                                                <option [value]="item" *ngFor="let item of userDropdownList"></option>
                                            </datalist>
                                            <label class="floating-label-special">Manager Name*</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                        <mat-error *ngIf="f.managerName.touched && f.managerName.invalid"
                                            class="alert alert-danger">
                                            <mat-error *ngIf="f.managerName.errors.required">Manager Name is
                                                required</mat-error>
                                        </mat-error>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <select formControlName="emailIdRequired" required>
                                                <option value="" disabled selected>Email ID Required</option>
                                                <option [ngValue]="true">Yes</option>
                                                <option [ngValue]="false">No</option>
                                            </select>
                                            <label class="floating-label floating-label-special">Email ID
                                                Required*</label>
                                            <i class="ri-file-list-line"></i>
                                        </div>
                                        <mat-error *ngIf="f.emailIdRequired.touched && f.emailIdRequired.invalid"
                                            class="alert alert-danger">
                                            <mat-error *ngIf="f.email.errors.required">This field is
                                                required</mat-error>
                                        </mat-error>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <select formControlName="permanentOrContractor" required>
                                                <option value="" disabled selected>Employment Contract</option>
                                                <option value="Permanent">Permanent</option>
                                                <option value="Contractor">Contractor</option>
                                            </select>
                                            <label class="floating-label floating-label-special">Employment
                                                Contract*</label>
                                            <i class="ri-phone-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input">
                                        <div class="input-item">
                                            <select formControlName="systemRequiredBoolean"
                                                (change)="checkSystemStatus($event.target.value)" required>
                                                <option value="" disabled selected>System Required</option>
                                                <option [ngValue]="true">Yes</option>
                                                <option [ngValue]="false">No</option>
                                            </select>
                                            <label class="floating-label floating-label-special">System
                                                Required*</label>
                                            <i class="ri-phone-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4" *ngIf="this.isSystem">
                                    <div class="input">
                                        <div class="input-item">
                                            <select formControlName="systemRequired">
                                                <option value="" disabled selected>Select System Type</option>
                                                <option value="Workstation">Workstation</option>
                                                <option value="Laptop">Laptop</option>
                                            </select>
                                            <label class="floating-label-special">System Type*</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex gap-2 mt-3 justify-content-end">
                                <div *ngIf="!this.userCreationId">
                                    <button class="btn btn-primary" [disabled]="!usersForm.valid ? true : null"
                                        (click)="userCreation()">Submit</button>
                                </div>
                                <div *ngIf="this.userCreationId">
                                    <button class="btn btn-primary" [disabled]="!usersForm.valid ? true : null"
                                        (click)="updateUserCreation()">Save</button>
                                </div>
                                <div>
                                    <button class="btn btn-primary" (click)="backToOnboarding()">Cancel</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </section>
    </article>
</main>